export const FORM_DEFAULT_VALUES = {
  workspaceName: '',
};

export const WORKSPACE_NAME = 'workspaceName';
